module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inp-modal modal fade noselect",
    attrs: {
      "id": "modalAlerte",
      "data-testid": "alertModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.canClose) ? _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close",
      "title": "Fermer"
    },
    on: {
      "click": function($event) {
        _vm.annuler()
      }
    }
  }, [_c('span', {
    staticClass: "fas fa-times"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.isLoadingAnimationVisible != true) ? _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row mb-3"
  }, [_c('div', {
    staticClass: "col text-center",
    attrs: {
      "data-testid": "alertModal-message"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.message)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row-custom mt-3 mb-3 d-flex align-items-center"
  }, [(_vm.isBooleanChoiceVisible) ? _c('div', {
    staticClass: "tw-cursor-pointer tw-flex tw-gap-1",
    on: {
      "click": function($event) {
        _vm.toggleBooleanChoice()
      }
    }
  }, [_c('span', {
    staticClass: "fa-solid tw-duration-200 tw-text-3xl",
    class: _vm.booleanChoiceValue ? 'fa-toggle-on tw-text-sky-500' : 'fa-toggle-off tw-text-gray-500'
  }), _vm._v(" "), _c('span', {
    staticClass: "tw-text-lg tw-pt-0.5"
  }, [_vm._v(_vm._s(_vm.booleanChoiceText))])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.isLoadingAnimationVisible != true) ? _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "justify-content": "center"
    }
  }, [_c('div', {
    staticClass: "area-action"
  }, [(_vm.isYesVisible) ? _c('button', {
    staticClass: "inp-button-modal valid",
    attrs: {
      "type": "submit",
      "data-testid": "alertModal-validate-button"
    },
    on: {
      "click": function($event) {
        _vm.valider()
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.yesText))])]) : _vm._e(), _vm._v(" "), (_vm.isNoVisible) ? _c('button', {
    staticClass: "inp-button-modal cancel ml-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.annuler()
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.noText))])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.isLoadingAnimationVisible == true) ? _c('div', {
    staticStyle: {
      "height": "90px"
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Chargement en cours...")]), _vm._v(" "), _c('loader')], 1) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row mb-3"
  }, [_c('div', {
    staticClass: "col text-center"
  }, [_c('span', {
    staticClass: "fas fa-exclamation-triangle fa-3x",
    staticStyle: {
      "opacity": "0.5",
      "color": "red"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hide"
  }, [_c('span', {
    staticClass: "fas fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hide"
  }, [_c('span', {
    staticClass: "fas fa-times"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fb04e96"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modalComponents/modalAlerte/modalAlerte.vue.html
// module id = xJzE
// module chunks = 2